export enum RentalLeaseStatus {
  Active = 10,
  LeaseRenewed = 11,
  MTM = 12,
  OnNotice = 13,
  Eviction = 18
}